import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Table, Badge } from "react-bootstrap";
import { useAuth } from "../context/AuthContext";
import DemoBanner from "../components/DemoBanner";
import { API_BASE, getAuthHeaders } from "../utils/api";

const ACAO_LABELS = {
  criar_usuario: { label: "Criar usuário", variant: "success" },
  editar_usuario: { label: "Editar usuário", variant: "warning" },
  deletar_usuario: { label: "Deletar usuário", variant: "danger" },
  fechar_folha: { label: "Fechar folha", variant: "primary" },
};

const AcaoBadge = ({ acao }) => {
  const info = ACAO_LABELS[acao] || { label: acao, variant: "secondary" };
  return <Badge bg={info.variant}>{info.label}</Badge>;
};

export default function Auditoria() {
  const { token, isDemo } = useAuth();
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isDemo) {
      setItems([
        { id: 1, acao: "criar_usuario", tabela: "usuarios", registro_id: "5", detalhe: "{\"nome\":\"JOAO\"}", criado_em: new Date().toISOString(), usuario: "Admin" },
        { id: 2, acao: "fechar_folha", tabela: "folhas_pagamento", registro_id: "1", detalhe: "{\"bonus_fechados\":12}", criado_em: new Date(Date.now() - 86400000).toISOString(), usuario: "Admin" },
      ]);
      setTotal(2); setPages(1);
      return;
    }
    setLoading(true);
    fetch(`${API_BASE}/audit/?page=${page}&per_page=30`, { headers: getAuthHeaders(token) })
      .then(r => r.json())
      .then(d => { setItems(d.items || []); setTotal(d.total || 0); setPages(d.pages || 1); })
      .finally(() => setLoading(false));
  }, [page, token, isDemo]);

  const fmtDate = (iso) => iso ? new Intl.DateTimeFormat("pt-BR", { dateStyle: "short", timeStyle: "short" }).format(new Date(iso)) : "-";

  const fmtDetalhe = (d) => {
    try { const obj = JSON.parse(d); return Object.entries(obj).map(([k, v]) => `${k}: ${v}`).join(" | "); }
    catch { return d || "-"; }
  };

  return (
    <Container fluid className="main-content">
      {isDemo && <DemoBanner />}
      <Row className="align-items-center mb-4">
        <Col>
          <h2 style={{ color: "var(--brand-secondary)" }}>
            <i className="bi bi-shield-check me-2" style={{ color: "var(--brand-primary)" }}></i>Auditoria
          </h2>
          <p className="text-muted small mb-0">{total} registro(s) encontrado(s)</p>
        </Col>
      </Row>

      <Card className="border-0 shadow-sm overflow-hidden">
        <div className="table-responsive">
          <Table hover className="align-middle mb-0">
            <thead style={{ backgroundColor: "var(--brand-secondary)", color: "var(--brand-text-on-dark)" }}>
              <tr>
                <th className="border-0">Data</th>
                <th className="border-0">Usuário</th>
                <th className="border-0">Ação</th>
                <th className="border-0">Tabela</th>
                <th className="border-0">Detalhe</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="5" className="text-center py-4"><span className="spinner-border spinner-border-sm" /></td></tr>
              ) : items.length === 0 ? (
                <tr><td colSpan="5" className="text-center py-4 text-muted"><i className="bi bi-inbox fs-3 d-block mb-2"></i>Nenhum registro encontrado.</td></tr>
              ) : items.map(item => (
                <tr key={item.id} className="border-bottom">
                  <td className="text-nowrap small text-muted">{fmtDate(item.criado_em)}</td>
                  <td className="fw-semibold">{item.usuario}</td>
                  <td><AcaoBadge acao={item.acao} /></td>
                  <td className="text-muted small">{item.tabela || "-"}</td>
                  <td className="small text-muted" style={{ maxWidth: 300, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{fmtDetalhe(item.detalhe)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        {pages > 1 && (
          <div className="d-flex justify-content-center gap-2 py-3">
            <button className="btn btn-sm btn-outline-secondary" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>Anterior</button>
            <span className="align-self-center small text-muted">{page} / {pages}</span>
            <button className="btn btn-sm btn-outline-secondary" disabled={page >= pages} onClick={() => setPage(p => p + 1)}>Próxima</button>
          </div>
        )}
      </Card>
    </Container>
  );
}
